import { useState } from 'react';
import { Modal } from '../common/Modal.tsx';

interface Props {
  onCreate: (name: string) => void;
  onClose: () => void;
}

// 서버 경로 규칙과 동일하게 미리 걸러 준다 (docs/06-auth-security.md §5)
const FORBIDDEN = /[\\/:*?"<>|]/;

export function NewFolderDialog({ onCreate, onClose }: Props) {
  const [name, setName] = useState('제목 없는 폴더');
  const trimmed = name.trim();

  const problem = trimmed.length === 0
    ? '이름을 입력해 주세요'
    : FORBIDDEN.test(trimmed)
      ? '\\ / : * ? " < > | 는 쓸 수 없습니다'
      : trimmed === '.' || trimmed === '..'
        ? '사용할 수 없는 이름입니다'
        : null;

  return (
    <Modal
      title="새 폴더"
      onClose={onClose}
      footer={
        <>
          <button className="btn" onClick={onClose}>취소</button>
          <button
            className="btn btn--primary"
            disabled={problem !== null}
            onClick={() => { onCreate(trimmed); }}
          >
            만들기
          </button>
        </>
      }
    >
      <div className="field">
        <label htmlFor="folder-name">폴더 이름</label>
        <input
          id="folder-name"
          className={problem ? 'input input--error' : 'input'}
          value={name}
          autoFocus
          onFocus={(e) => { e.target.select(); }}
          onChange={(e) => { setName(e.target.value); }}
          onKeyDown={(e) => { if (e.key === 'Enter' && !problem) onCreate(trimmed); }}
        />
        {problem && <span className="error-text">{problem}</span>}
      </div>
    </Modal>
  );
}
